export default __webpack_public_path__ + "static/media/eugeny.13bbeb6f.png";